<template>
  <p>
    Grove Collaborative operates an ecommerce service and related services
    through grove.com, grove.co, mobile applications, and related sites
    accessible to mobile devices, tablets, and other connected devices
    (collectively, the
    <strong>“Grove Collaborative Service”</strong> or
    <strong>“Service”</strong>). As used in this policy,
    <strong>“Grove Collaborative”</strong>
    refers to Grove Collaborative, Inc. and its subsidiaries. We may refer to
    Grove Collaborative as
    <strong>“we”</strong>, <strong>“us”</strong>, or <strong>“our”</strong>. We
    may refer to you as <strong>“consumer”</strong>, <strong>“you”</strong>, or
    <strong>“your”</strong>.
  </p>
</template>
